export function filterByText (item, queryText, itemText) {
	return itemText
		.toLocaleLowerCase()
		.indexOf(queryText.trim().toLocaleLowerCase()) > -1 ||
		item.id
			.toString()
			.indexOf(queryText.trim().toString()) > -1
}
